import { render, staticRenderFns } from "./Course.html?vue&type=template&id=65f0bba5&scoped=true&"
import script from "./Course.vue?vue&type=script&lang=ts&"
export * from "./Course.vue?vue&type=script&lang=ts&"
import style0 from "./Course.scss?vue&type=style&index=0&id=65f0bba5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f0bba5",
  null
  
)

export default component.exports